import React from "react";

import { Button, EButtonVariant } from "components/Button/Button";

import useDocuments from "../../hooks/useDocuments";

const Footer = () => {
  const { saveDocItem } = useDocuments();
  return (
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-row justify-between items-center">
        <Button
          icon="galochka"
          variant={EButtonVariant.SECONDARY}
          onClick={saveDocItem}
        >
          Сохранить
        </Button>
      </div>
    </div>
  );
};

export default Footer;
